import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@/config/queryKeys";
import { fetchCreditBalance } from "@/server/services/stripeService";

interface UseCreditBalanceOptions {
  /**
   * Whether to run the query. Defaults to `true` — the credit-balance DTO is
   * fetched for ALL users (not just subscribers) so trial state and stranded
   * add-on credits are visible to free / churned users too.
   */
  enabled?: boolean;
}

export function useCreditBalance(options?: UseCreditBalanceOptions) {
  return useQuery({
    queryKey: QUERY_KEYS.stripeCreditBalance,
    queryFn: fetchCreditBalance,
    staleTime: 30_000,
    enabled: options?.enabled ?? true,
  });
}
